/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/code/custom-elements';

import { defineCustomElement as defineOsdsCode } from '@ovhcloud/ods-stencil/components/code/custom-elements/osds-code.js';


export const OsdsCode = /*@__PURE__*/ defineContainer<JSX.OsdsCode>('osds-code', defineOsdsCode, [
  'color',
  'contrasted',
  'size',
  'odsCodeCopy'
]);

